import { render, staticRenderFns } from "./SmartTableQuestionLayout.vue?vue&type=template&id=c62431da&scoped=true"
import script from "./SmartTableQuestionLayout.vue?vue&type=script&lang=js"
export * from "./SmartTableQuestionLayout.vue?vue&type=script&lang=js"
import style0 from "./SmartTableQuestionLayout.vue?vue&type=style&index=0&id=c62431da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c62431da",
  null
  
)

export default component.exports